<script>

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

var urlParams =new URLSearchParams(window.location.search)
</script>

<div class="pageContainer">
  
  <StandardHeader />
  <div class="mainContentSection" style="min-width:300px">
    <a href={urlParams.get('confirmation_url')}>
      <button id="LoginButton" class="primary" style="float:right" type="submit">Complete your Sign In</button> 
    </a>
  </div>
  <StandardFooter/>

</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px);  display: flex; flex-direction: column; align-self: center; justify-content: center}
</style>
